import {Injectable} from '@angular/core'
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar'
import {I18nService} from '../i18n/i18n.service'

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'bottom';

    constructor(private snack: MatSnackBar,
                private i18nSvc: I18nService) {
    }

    /**
     * Show information snackbar
     * use .info-snackbar class in general styles.css file to change appearance
     * @param message displayed text
     * @param okBtn if true, wait for close
     */
    public info(message: string, okBtn = false): void {
        this.openSnackbar(SnackType.info, message, okBtn);
    }

    /**
     * Show error snackbar
     * use .error-snackbar class in general styles.css file to change appearance
     * @param message displayed text
     * @param okBtn if true, wait for close
     * @param details detail information to be shown in console
     */
    public error(message: string, okBtn = false, details = ''): void {
        if (details.length) console.error(details);
        this.openSnackbar(SnackType.error, message, okBtn);
    }

    /**
     * open snackbar component
     * @param type info | error
     * @param message text to be shown
     * @param okBtn true to show OK button and wait till pressed to close
     * @private
     */
    private openSnackbar(type: SnackType, message: string, okBtn: boolean): void {
        this.snack.open(
            this.i18nSvc.translate(message),
            okBtn ? 'OK' : undefined,
            {
                duration: !okBtn ? 3000 : undefined,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
                panelClass: type === SnackType.error ? 'shared-snackbar-error' : 'shared-snackbar-info'
            });
    }
}

enum SnackType {
    info,
    error
}
